import { render, staticRenderFns } from "./ConfigDefect.vue?vue&type=template&id=7fa07446&scoped=true&"
import script from "./ConfigDefect.vue?vue&type=script&lang=js&"
export * from "./ConfigDefect.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDefect.vue?vue&type=style&index=0&id=7fa07446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa07446",
  null
  
)

export default component.exports